import React from 'react';
import { Typography } from 'antd';


const HeaderItemDisplay = ({ text, label }) => {
    //console.log(text)
    //console.log(label)
    return (
        <>
            <div style={{ alignContent: 'center' }}>
                <div><Typography.Text strong={true} level={2}>{label}</Typography.Text></div>
                <div>{text}</div>
            </div>
        </>
    );
};

export default HeaderItemDisplay;
